import React, { useMemo } from "react";
import { isString } from "@common/helpers/typeGuards";
import { TransactionRuleCondition } from "@common/types/transactionRule";
import { useCategoryLabelGetter } from "@hooks/useCategoryLabelGetter";
import { RuleTagRow } from "../RuleTagRow";

interface Props {
    condition: TransactionRuleCondition;
}

export const RuleSuggestedCategoryCondition: React.FC<Props> = ({
    condition,
}) => {
    const categoryLabelGetter = useCategoryLabelGetter();

    const categoryLabel = useMemo(() => {
        if (isString(condition.value)) {
            return categoryLabelGetter(condition.value);
        }
    }, [categoryLabelGetter, condition.value]);

    if (!categoryLabel) {
        return null;
    }

    return (
        <RuleTagRow
            label="Suggested category"
            type="condition"
            values={[categoryLabel]}
        />
    );
};
